/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { isBoolean } from 'lodash'

import { DialogTechnologyCompany } from './components'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import useStyles from './styles'
import helpers from 'helpers'

const TechnologicalControlSection = ({
  questionnaire,
  setLoading,
  refresh,
}) => {
  const classes = useStyles()
  const snackbar = useSnackbar()

  const [questionOutsourceSoftware, setQuestionOutsourceSoftware] = useState()
  const [openDialogTechnologyCompany, setOpenDialogTechnologyCompany] =
    useState(false)

  const hasDynamicQuestions = questionnaire?.hasDynamicQuestions

  const handleChangeDynamicQuestions = async (event) => {
    setQuestionOutsourceSoftware(event.target.value === 'true')
  }

  const updateQuestionnaire = async () => {
    setLoading(true)
    try {
      await service.dponet.questionnaires.handleDynamicQestions({
        questionnaireId: questionnaire?.id,
        hasDynamicQuestions: questionOutsourceSoftware,
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error.response.data.error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (questionOutsourceSoftware !== undefined) updateQuestionnaire()
  }, [questionOutsourceSoftware])

  useEffect(() => {
    if (!isBoolean(hasDynamicQuestions)) setOpenDialogTechnologyCompany(true)
  }, [])

  return (
    <Card className={classes.card}>
      <Typography variant="h4">
        Sua empresa faz ou terceiriza software?
      </Typography>

      <Box py={1} display="flex">
        <FormControl component="fieldset">
          <RadioGroup
            name="hasDynamicQuestions"
            value={String(questionOutsourceSoftware)}
            onChange={handleChangeDynamicQuestions}
            className={classes.boxButtons}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Sim"
              checked={hasDynamicQuestions}
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Não"
              checked={hasDynamicQuestions === false}
            />
          </RadioGroup>
        </FormControl>
      </Box>

      <Alert className={classes.levelAlert} variant="filled" severity="info">
        <Grid container>
          <Grid item xs={12}>
            <Typography className={classes.levelAlertTitle}>
              Essa pergunta poderá ser modificada, mas qualquer alteração
              resultará em mudanças nos questionários correspondentes.
            </Typography>
            <Typography>
              “Desenvolvimento de software é o processo de conceber,
              especificar, programar, testar e corrigir programas de computador
              para resolver problemas ou automatizar tarefas específicas,
              seguindo metodologias e boas práticas para garantir eficiência e
              qualidade no produto final.”
            </Typography>
          </Grid>
        </Grid>
      </Alert>

      <DialogTechnologyCompany
        questionnaireId={questionnaire?.id}
        open={openDialogTechnologyCompany}
        setOpen={setOpenDialogTechnologyCompany}
        setLoading={setLoading}
        refresh={refresh}
      />
    </Card>
  )
}

export default TechnologicalControlSection
